<template>
  <Modal v-model="allowCancellationOfOrdersModal" :title="$t('key1004547')" width="500"
    :transfer="false" :mask-closable="false" @on-visible-change="allowCancellationOfOrdersChange">
    <Form ref="allowCancellationOfOrdersForm" :model="allowCancellationOfOrdersForm" :rules="ruleValidate"
      :label-width="100" @submit.native.prevent>
      <Row style="width: 95%;">
        <h2 class="mb15 ml18">{{ $t('key1004549') }}</h2>
        <template v-if="cancelPrice">
          <div class="mb20">
            {{ $t('key1001077') }}
            <span class="themeColor ml3 mr4">{{ timer }}</span>
            {{ $t('key1001078') }}
            <span class="themeColor">{{ $t('key1001070') + cancelPrice + ' ' + currencyState }}</span>
            {{ $t('key1001079') }}
          </div>
        </template>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1004548')" prop="invalidhandlerCost">
            <div class="flex align-items-center">
              <InputNumber :max="99999999" :min="0" :formatter="(value) => formatterNumber(value, 2)"
                v-model="allowCancellationOfOrdersForm.invalidhandlerCost" class="width_200">
              </InputNumber>
              <span class="ml5">{{ currencyState }}</span>
            </div>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="allowCancellationOfOrdersModal = false">{{ $t('key1000112') }}</Button>
      <Button type="error" @click="allowCancellationOfOrdersBtn">{{ $t('key1004550') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {calculateDiffTime, formatterNumber, getOrderLogisticsConsumption} from "@/utils/common";

export default {
  name: 'allowCancellationOfOrdersModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      allowCancellationOfOrdersModal: false,
      allowCancellationOfOrdersForm: {
        invalidhandlerCost: null
      },
      ruleValidate: {
        invalidhandlerCost: [
          {type: 'number', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004546'), trigger: 'change'}
        ],
      },
      ymsPackageId: null,
      cancelPrice: 0,
      timer: null
    };
  },
  methods: {
    formatterNumber,
    // 初始化数据
    initAllowCancellationOfOrdersData(obj) {
      this.ymsPackageId = obj.ymsPackageId;
      getOrderLogisticsConsumption(obj.ymsPackageId).then((data) => {
        if (data) {
          this.cancelPrice = data.cancelPrice || 0;
          let trackingNumberTime = obj.trackingNumberTime || '';
          if (trackingNumberTime) {
            trackingNumberTime = this.$uDate.dealTime(trackingNumberTime, 'fulltime');
            this.timer = calculateDiffTime(trackingNumberTime);
            console.log('======timer======', this.timer);
          }
        }
      });
      this.allowCancellationOfOrdersModal = true;
    },
    // 允许取消订单
    allowCancellationOfOrdersBtn() {
      let v = this;
      let query = {
        invalidhandlerCost: v.allowCancellationOfOrdersForm.invalidhandlerCost,
        invalidhandlerCostCurrency: v.currencyState,
        ymsPackageIds: [v.ymsPackageId]
      };
      v.$refs['allowCancellationOfOrdersForm'].validate((valid) => {
        if (valid) {
          v.axios.put(api.put_ymsPackageInfo_invalidConfirm, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.allowCancellationOfOrdersModal = false;
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 监听弹窗
    allowCancellationOfOrdersChange(value) {
      if (!value) {
        this.$refs['allowCancellationOfOrdersForm'].resetFields();
        this.ymsPackageId = null;
        this.cancelPrice = 0;
        this.timer = null;
      }
    }
  },
};
</script>

<style lang="less">

</style>
